
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.33332 5C7.08932 5 6.85586 5.09589 6.68416 5.2657C6.51256 5.43543 6.41666 5.66503 6.41666 5.90385V9.84545C6.41666 11.3083 7.00422 12.7119 8.051 13.7472C9.09787 14.7825 10.5183 15.3647 12 15.3647C13.4817 15.3647 14.9021 14.7825 15.949 13.7472C16.9958 12.7119 17.5833 11.3083 17.5833 9.84545V5.90385C17.5833 5.66503 17.4874 5.43543 17.3158 5.2657C17.1441 5.09589 16.9107 5 16.6667 5C16.4227 5 16.1892 5.09589 16.0175 5.2657C15.8459 5.43543 15.75 5.66503 15.75 5.90385V9.84545C15.75 10.8307 15.3542 11.7751 14.6507 12.4709C13.9472 13.1666 12.9937 13.557 12 13.557C11.0063 13.557 10.0528 13.1666 9.34932 12.4709C8.64576 11.7751 8.24999 10.8307 8.24999 9.84545V5.90385C8.24999 5.66503 8.15409 5.43543 7.98248 5.2657C7.81078 5.09589 7.57732 5 7.33332 5ZM6.16667 17.5C5.92266 17.5 5.68921 17.5959 5.51751 17.7657C5.3459 17.9354 5.25 18.2607 5.25 18.4995C5.25 18.7383 5.3459 19.0646 5.51751 19.2343C5.68921 19.4041 5.92266 19.5 6.16667 19.5H17.8333C18.0773 19.5 18.3108 19.4041 18.4825 19.2343C18.6541 19.0646 18.75 18.7383 18.75 18.4995C18.75 18.2607 18.6541 17.9354 18.4825 17.7657C18.3108 17.5959 18.0773 17.5 17.8333 17.5H6.16667Z","fill":"#10001F"}})])
          )
        }
      }
    